var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("Title", {
        attrs: {
          title: "Sprachen",
          "completion-type": _vm.completionType,
          parent: ""
        },
        on: { edit: _vm.edit }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("SelectedItems", {
            staticClass: "no-left-padding",
            attrs: {
              selected: _vm.value,
              "characteristic-items": _vm.meta.language,
              "specificities-provider": _vm.itemSpecificitiesProvider,
              "label-appendix-provider": _vm.labelAppendixProvider
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }